import state from "./states";
import actions from "./actions";
import mutations from "./mutations";

const getters = {
  getEmployeeDailyAttendanceList: (state) => state.items,
  getEmployeeDailyAttendancePagination: (state) => state.pagination,
  getEmployeeDailyAttendanceBusy: (state) => state.isBusy,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
